// utils/urlUtils.js

// Функция для создания slug из кириллического текста
export const createSlug = (text) => {
    // Проверяем, что text существует и это строка
    if (!text || typeof text !== 'string') {
        return 'product' // возвращаем дефолтное значение
    }

    const translitMap = {
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo',
        'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm',
        'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
        'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch', 'ш': 'sh', 'щ': 'sch',
        'ъ': '', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu', 'я': 'ya',
        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'Yo',
        'Ж': 'Zh', 'З': 'Z', 'И': 'I', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M',
        'Н': 'N', 'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
        'Ф': 'F', 'Х': 'H', 'Ц': 'C', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Sch',
        'Ъ': '', 'Ы': 'Y', 'Ь': '', 'Э': 'E', 'Ю': 'Yu', 'Я': 'Ya'
    }

    // Проверяем, есть ли кириллица в тексте
    const hasCyrillic = /[а-яё]/i.test(text)

    let result = text

    if (hasCyrillic) {
        // Если есть кириллица - транслитерируем
        result = text
            .split('')
            .map(char => translitMap[char] || char)
            .join('')
    }

    // Приводим к нижнему регистру и заменяем всё кроме букв и цифр на дефисы
    return result
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') // убираем дефисы в начале и конце
}

// Функция для создания красивого URL из названия категории
export const createCategorySlug = (categoryName) => {
    if (!categoryName || typeof categoryName !== 'string') {
        return 'category'
    }

    // Для категорий оставляем как есть, если английские
    if (!/[а-яё]/i.test(categoryName)) {
        return categoryName // TV останется TV
    }

    // Если русская категория - транслитерируем
    return createSlug(categoryName)
}

// Функция для создания красивого URL из описания товара
export const createProductSlug = (description) => {
    if (!description || typeof description !== 'string') {
        return 'product'
    }

    // Убираем кавычки, размеры в дюймах и лишние символы
    let cleanDescription = description
        .replace(/"/g, '') // убираем кавычки
        .replace(/\d+"/g, '') // убираем размеры типа 43"
        .replace(/\s+/g, ' ') // множественные пробелы в один
        .trim()

    return createSlug(cleanDescription)
}

